// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './visitStatusIcon.scss'
import Tippy from '@tippyjs/react'
import { useDispatch } from 'react-redux'
import trashIcon from '../../../images/common/trash-red.png'
import checkIcon from '../../../images/common/check-transparent.png'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import editIcon from '../../../images/common/editIntake.png'
import { text } from '../constants'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { changeVisitStatus, setVisitError } from '../../../store/visits/VisitsActions'
// @ts-expect-error TS6192 -- MIGRATION: not approved, fix when encountered
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getVisitStatusIcon = (isCancellationAllowed) => (isCancellationAllowed ? trashIcon : checkIcon)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getTooltipValue = (isCancellationAllowed) => {
  return isCancellationAllowed ? text.CANCEL_VISIT : text.RESOLVE_VISIT
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const getChangeVisitStatusData = ({ isCancellationAllowed, visitId }) => {
  const newStatusValue = isCancellationAllowed ? text.CANCEL_VISIT : text.RESOLVE_VISIT
  return {
    newStatus: newStatusValue,
    visitId,
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const VisitStatusIcon = ({ isCancellationAllowed, visitId }) => {
  const dispatch = useDispatch()

  const setAction = () => {
    const newVisitStatusData = getChangeVisitStatusData({ isCancellationAllowed, visitId })
    dispatch(changeVisitStatus(newVisitStatusData))
  }

  const iconSrc = getVisitStatusIcon(isCancellationAllowed)
  const tooltipContent = getTooltipValue(isCancellationAllowed)
  const altText = isCancellationAllowed ? 'Cancel Visit' : 'Resolve Visit'

  const iconWrapperClass = `visit-status-icon-main-wrapper`

  const iconElement =
    iconSrc ?
      <section
        className={iconWrapperClass}
        onClick={setAction}
        role='button'
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            setAction()
          }
        }}>
        <img className='visit-status-icon' src={iconSrc} alt={altText} />
      </section>
    : null

  return tooltipContent ?
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      <Tippy duration='0' content={tooltipContent} className='tooltip-container'>
        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        {iconElement}
      </Tippy>
    : iconElement
}
